import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import { Input, message,Statistic,Progress  } from 'antd';
import {balanceOf, signer} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import {addPledgeBuy, unPledgeBuy, getPledgeIndex} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Index = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [allBonusPledge,setAllBonusPledge] = useState(0)
    const [allPledge,setAllPledge] = useState(0)
    const [maxBonus,setMaxBonus] = useState(0)
    const [min,setMin] = useState("")
    const [jing,setJing] = useState(0)
    const [dong,setDong] = useState(0)
    const [jingPer,setJingPer] = useState(0)
    const [dongPer,setDongPer] = useState(0)
    const [price,setPrice] = useState(0)

    const [needUsdt,setNeedUsdt]=useState("")
    
    const [pledgeRecords,setPledgeRecords] = useState([])
    const [balanceUsdt,setBalanceUsdt]=useState(null)
    const [isLock,setIsLock]=useState(false)
    const [value,setValue] = useState("")
    const [showJoin,setShowJoin] = useState(false)


    const _balanceOf = () =>{
        if(props.address.length<=0 || !props.isLogin) return false
        balanceOf(props.address,'usdt').then(res=>{
            console.log(res)
            setBalanceUsdt(res)
        })

    }




    const _openPledge = () =>{
        if(props.address.length<=0){
            message.error(t('node.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('node.请先绑定地址'))
            return false
        }
        setShowJoin(true)
    }

    
    const _rand= () =>{
        // if(props.address.length<=0) return false
        if(props.address.length<=0){
            message.error(t('node.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            message.error(t('node.请先绑定地址'))
            return false
        }

       
        if(min.length == 0){
            return false
        }
        if(price == 0){
            return false
        }
        if(!needUsdt){
            message.error(t('p.请输入存入数量'))
            return false
        }
        if(needUsdt.length<=0){
            message.error(t('p.请输入存入数量'))
            return false
        }
        if(needUsdt<100){
            message.error(t('p.最低100USDT'))
            return false
        }
        

        if(parseFloat(needUsdt)>parseFloat(balanceUsdt)){
            console.log(needUsdt)
            console.log(balanceUsdt)
            message.error(t('p.余额不足'))
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)

        
        signer(props.address).then(res=>{
            addPledgeBuy({
                address:props.address,
                value:needUsdt.toString(),
                pass:res.pass
            }).then(
                res=>{
                    if(res.code===0){
                        message.success(res.msg)
                        setNeedUsdt("")
                        setNum(num+1)
                        
                    }else{
                        message.error(res.msg)
                    }
                    setIsLock(false)
                    setShowJoin(false)
                    
                   
                },error=>{
                    setIsLock(false)
                    message.error(error)
                })

        },error=>{
            message.error(error)
            setIsLock(false)
        })
        
            



    }



    const _getPledgeIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getPledgeIndex().then(res=>{
            if(res.code === 0 ){

               
                setAllPledge(res.data.allPledge)
                setAllBonusPledge(res.data.allBonusPledge)
                setMaxBonus(res.data.maxBonus)
                setPrice(res.data.price)
                setJing(res.data.jing)
                setDong(res.data.dong)
                setJingPer(res.data.jingPer)
                setDongPer(res.data.dongPer)
                setBalanceUsdt(res.data.usdt_n)
                setMin(res.data.min)

                if(res.data.list != null){
                    setPledgeRecords(res.data.list)
                }

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

    const hui = (_price,_state,_orderNum) =>{
        console.log(_price)
        if (_state != 0){
            message.error(t('p.不能重复赎回'))
            return false
        }

        if(parseFloat(_price*3)>parseFloat(price)){
            message.error(t('p.当前ETH价值不满足3倍涨幅！'))
            return false
        }

       
        
        if(isLock) return false;
        setIsLock(true)
        signer(props.address).then(res=>{
            unPledgeBuy({address:props.address,orderNum:_orderNum,pass:res.pass}).then(res=>{
                if(res.code===0){
                    message.success(res.msg)
                }else{
                    message.error(res.msg)
                }
                setIsLock(false)
                setShowJoin(false)
                setNum(num+1)
            },error=>{
                setIsLock(false)
                message.error(res.msg)
            })

        },error=>{
            message.error(error)
            setIsLock(false)
        })
    }





    useEffect(() => {
            window.scrollTo(0, 0)
            _getPledgeIndex()
            // _balanceOf()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
        <CSSTransition
            in={showJoin}
            unmountOnExit={true}
            classNames='coder'
            timeout={500}
            appear
            onEnter={(e) => console.log('开始进入动画')}
            onEntering={(e) => console.log('执行进入动画')}
            onEntered={(e) => console.log('进入动画结束')}
            onExit={(e) => console.log('开始离开动画')}
            onExiting={(e) => console.log('正在离开动画')}
            onExited={(e) => console.log('离开动画结束')}>
            <div className=' w-full h-screen bg-black fixed left-0 top-12 bg-opacity-90 inout1 '>
                        <div className=' w98 mx-auto  px-3 py-4 border-t-4 border-t-logo border-b-4 border-b-logo  rounded-t-xl  rounded-b-xl bg-gradient-to-r from-black to-black-right mt-10 '>
                            <div className='w-full relative flex flex-row justify-center items-center text-gray-400'>
                                <span className=' text-white text-lg font-bold'>
                                {t('p.新建')}
                                    {/* {t('funds.参与')} */}
                                    </span>
                                <CloseOutlined onClick={()=>setShowJoin(false)} className=' absolute right-0  text-xl' />
                            </div>

                            <div className='w-full h-28 mt-5 bg-funds-body border border-head-border rounded-xl px-4 py-4 mb-1'>
                                <div className='w-full flex flex-row justify-between items-center mt-1'>
                                    <span className=' text-xs text-gray-300 font-bold'>{t('p.输入存入数量')}：</span>
                                    <span className=' text-xs text-gray-300 font-bold'>{t('p.余额')}：
                                    <NumberFormat
                                       thousandsGroupStyle="thousand"
                                       value={balanceUsdt}
                                       prefix=""
                                       decimalSeparator="."
                                       displayType="text"
                                       type="text"
                                       thousandSeparator={true}
                                       allowNegative={false}
                                       decimalScale={2} />
                                    </span>
                                </div>

                                <div className='w-full flex flex-row justify-between items-center mt-4'>
                                    <div className=' w-2/3 h-12 flex flex-row items-center justify-start'>
                                        <input  type="number" onInput={(e)=>setNeedUsdt(e.target.value)} value={needUsdt}   className=' w-full h-12 text-2xl text-white input1 '     placeholder={t('p.最低：')+min}  />
                                    </div>
                                    <div className='w-1/3 h-12 flex flex-row items-center justify-end'>
                                        {/*<img alt='rr' className='  mr-2' src={require('../../assets/icon/flogo.png')} style={{"width":"30px"}}></img>*/}
                                        <span className='  text-lg font-bold text-logo'>
                                        USDT

                                        </span>
                                    </div>
                                </div>
                            </div>
                            {/* <div  className='w-full mt-5 bg-funds-body border border-head-border rounded-xl px-4 py-4 mb-1'>
                                <div className='w-full flex flex-row justify-between items-center mt-1'>
                                    <span className=' text-xs text-gray-300 font-bold'>{t('p.选择天数')}：</span>
                                    <div className=' flex flex-row justify-between items-center'>
                                        <div className=' w-12 h-8 ml-2 bg-logo rounded-lg flex flex-row justify-center items-center text-sm text-black font-bold'>
                                            50
                                        </div>
                                        <div className=' w-12 h-8 ml-2 border border-logo rounded-lg flex flex-row justify-center items-center text-sm text-logo font-bold'>
                                            180
                                        </div>
                                        <div className=' w-12 h-8 ml-2 border border-logo rounded-lg flex flex-row justify-center items-center text-sm text-logo font-bold'>
                                            280
                                        </div>
                                        <div className=' w-12 h-8 ml-2 border border-logo rounded-lg flex flex-row justify-center items-center text-sm text-logo font-bold'>
                                            380
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div  className='w-full mt-5 bg-funds-body border border-head-border rounded-xl px-4 py-4 mb-1'>
                                <div className='w-full flex flex-row justify-between items-center mt-1'>
                                    <span className=' text-xs text-gray-300 font-bold'>{t('p.结算基准')}：</span>
                                    <span className="text-orange-500 text-base font-bold ">
                                        0.2% / 日
                                    </span>
                                </div>

                            </div> */}

                            <div className='w-full flex flex-row justify-center items-center mt-5'>
                                <button onClick={()=>_rand()}   className='w-full h-12  shadow-sm shadow-logo    bg-gradient-to-r from-yellow1  to-yellow2  rounded-xl text-lg text-black font-extrabold  hover:opacity-60'>{t('p.发送')}</button>
                            </div>
                            <div className='w-full mt-5 bg-funds-body border border-head-border rounded-lg px-2 py-6 mb-1'>
                                <div className='w-full flex flex-row justify-start items-center '>
                                    <span className=' text-orange-500 text-base'>
                                        <WarningOutlined />
                                    </span>
                                    <span className='ml-2 text-red-500 text-xs'>
                                        {t('p.质押说明1')}
                                    </span>
                                </div>
                                {/* <div className='w-full flex flex-row justify-start items-center mt-4'>
                                    <span className=' text-orange-500 text-base'>
                                        <WarningOutlined />
                                    </span>
                                    <span className='ml-2 text-red-500 text-xs'>
                                        {t('p.质押说明2')}
                                    </span>
                                </div> */}
                            </div>

                        </div>
                    </div>
            </CSSTransition>


            <Head/>
            <div className=' w-full  px-4 mt-20 '>
                {/* title */}
                <div className=' w-full mt-9 mb-4 flex flex-row items-center justify-start '>
                    <div className=' w-2 h-5 mr-2 rounded-3xl bg-logo'></div>
                    <div className=' text-title text-xl  font-bold '>{t('p.数据台')}</div>
                </div>
                <div className=' w-full h-28  pt-5 pb-6 flex flex-row justify-around items-center  shadow-md shadow-gray-900   bg-gradient-to-r from-black  to-black-right  rounded-2xl'>
                   <div className=' flex flex-col justify-center'>
                        <div className=' flex flex-row items-center'>
                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"15px"}}></img>
                            <span className=' font-bold text-xs text-white'>{t('p.总存入数')}</span>
                        </div>
                        
                        <span className=' mt-5 font-bold text-xl text-logo text-center'><CountUp start={0} end={allPledge} duration="1" decimals={2} /></span>
                   </div>
                   <div className=' h-12 xian'></div>
                   <div className=' flex flex-col justify-center'>
                   <div className=' flex flex-row items-center'>
                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/ccerlogo.png')} style={{"width":"15px"}}></img>
                            <span className=' font-bold text-xs text-white'>{t('p.预期收益')}</span>
                        </div>
                        <span className=' mt-5 font-bold text-center text-xl text-logo'><CountUp start={0} end={maxBonus} duration="1" decimals={2} /></span>
                   </div>
                   <div className=' h-12 xian'></div>
                   <div className=' flex flex-col justify-center'>
                        <div className=' flex flex-row items-center'>
                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/ccerlogo.png')} style={{"width":"15px"}}></img>
                            <span className=' font-bold text-xs text-white'>{t('p.已获收益')}</span>
                        </div>
                        <span className=' mt-5 font-bold text-center text-xl text-logo'><CountUp start={0} end={allBonusPledge} duration="1" decimals={2}/></span>
                   </div>
                </div>

                <div className=" w-full mt-5 flex flex-row justify-between items-center">
                    <div className=' w-1/2  px-2 py-5 flex flex-row  shadow-md shadow-gray-900   bg-gradient-to-r from-black  to-black-right  rounded-2xl'>
                        <div className=' w-2/5'>
                            <Progress strokeColor="#F9C116"  type="circle" trailColor="#FFFFFF"   percent={jingPer} width={65} strokeWidth={10} />
                        </div>
                        <div className=' w-3/5 flex flex-col items-end'>
                            <div className=' flex flex-row  items-center'>
                                <img alt='rr' className=' mr-1' src={require('../../assets/icon/ccerlogo.png')} style={{"width":"15px"}}></img>
                                <span className=' font-bold text-xs text-white'>{t('p.结息收益')}</span>
                            </div>
                            <span className=' mt-5 font-bold text-xl text-logo'><CountUp start={0} end={jing} duration="1" decimals={2}/></span>
                        </div>
                    </div>
                    <div className=' w-1/2 ml-1 px-2 py-5 flex flex-row  shadow-md shadow-gray-900   bg-gradient-to-r from-black  to-black-right  rounded-2xl'>
                        <div className=' w-2/5'>
                            <Progress strokeColor="#F9C116"  type="circle" trailColor="#FFFFFF"   percent={dongPer} width={65} strokeWidth={10} />
                        </div>
                        <div className=' w-3/5 flex flex-col items-end'>
                            <div className=' flex flex-row  items-center'>
                                <img alt='rr' className=' mr-1' src={require('../../assets/icon/ccerlogo.png')} style={{"width":"15px"}}></img>
                                <span className=' font-bold text-xs text-white'>{t('p.贡献奖励')}</span>
                            </div>
                            <span className=' mt-5 font-bold text-xl text-logo'><CountUp start={0} end={dong} duration="1" decimals={2}/></span>
                        </div>
                    </div>
                </div>

                <button onClick={()=>_openPledge()}  className='w-full h-12 mt-7 flex flex-row items-center justify-center  shadow-sm shadow-logo    bg-gradient-to-r from-yellow1  to-yellow2  rounded-xl text-lg text-black font-extrabold  hover:opacity-60'>
                    <img alt='rr' className=' mr-1' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"25px"}}></img>
                    {t('p.增加存单')}
                </button>

                {/* title */}
                <div className=' w-full mt-9 mb-4 flex flex-row items-center justify-start '>
                    <div className=' w-2 h-5 mr-2 rounded-3xl bg-logo'></div>
                    <div className=' text-title text-xl  font-bold '>{t('p.存单凭证')}</div>
                </div>
                {
                    pledgeRecords.length>0?
                        pledgeRecords.map((item,index)=>{
                        return(
                            <div className=' w-full  px-2 pt-4 pb-4 mb-5 flex flex-col   shadow-md shadow-gray-900   bg-gradient-to-r from-black  to-black-right  rounded-2xl relative'>
                                <div className=' w-14 h-8 bg-gradient-to-r from-yellow1  to-yellow2 absolute top-6 right-0 flex flex-row justify-center items-center text-base text-black font-bold rounded-l-xl'>
                                    #{item.reg}
                                </div>
                                <div className='w-full flex flex-row justify-start  items-start'>
                                    <img alt='rr' className=' mr-2' src={require('../../assets/icon/logo.png')} style={{"width":"35px"}}></img>
                                    <div className=' flex flex-col items-start pt-3'>
                                        <span className=' text-xs text-black40 font-bold'>{item.order_num}</span>
                                        <div className=' mt-2 flex flex-row justify-start items-center'>
                                            <span className='text-xs text-black66 font-bold'>{t('p.本金数量')}：</span>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"12px"}}></img>
                                            <span className='text-xs text-logo font-bold'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value}
                                                fixedDecimalScale
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                        </div>
                                        <div className=' mt-1 flex flex-row justify-start items-center'>
                                            <span className='text-xs text-black66 font-bold'>{t('p.存单状态')}：</span>
                                            <span className={`${item.state==0?'text-green-500':'text-red-500'} text-xs font-bold`}>
                                                {item.state==0?t('p.生产中'):t('p.已失效')}
                                            </span>
                                        </div>
                                        <div className=' mt-1 flex flex-row justify-start items-center'>
                                            <span className='text-xs text-black66 font-bold'>{t('p.兑入币种')}：</span>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/usdtlogo.png')} style={{"width":"12px"}}></img>
                                            <span className='text-xs text-logo font-bold'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.value_real}
                                                prefix=""
                                                fixedDecimalScale
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                decimalScale={2} />
                                            </span>
                                            <span className='text-xs text-logo font-bold mx-1'>|</span>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/ethlogo.png')} style={{"width":"12px"}}></img>
                                            <span className='text-xs text-logo font-bold'>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.eth}
                                                fixedDecimalScale
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                decimalScale={4} />
                                            </span>
                                        </div>
                                        <div className=' mt-1 flex flex-row justify-start items-center'>
                                            <span className='text-xs text-black66 font-bold'>{t('p.兑入币价')}：</span>
                                            <img alt='rr' className=' mr-1' src={require('../../assets/icon/ethlogo.png')} style={{"width":"12px"}}></img>
                                            <span className='text-xs text-logo font-bold'>$
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={item.price}
                                                prefix=""
                                                fixedDecimalScale
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                decimalScale={4} />
                                            </span>
                                        </div>
                                        {/* <div className=' mt-1 flex flex-row justify-start items-center'>
                                            <span className='text-xs text-black66 font-bold'>{t('p.结算基准')}：</span>
                                            <span className='text-xs text-orange-500 font-bold'>
                                                0.1% * 50天
                                            </span>
                                        </div> */}
                                        {/* <div className=' mt-1 flex flex-row justify-start items-center'>
                                            <span className='text-xs text-black66 font-bold'>{t('p.赎回限期')}：</span>
                                            <span className='text-xs text-black66 font-bold'>
                                            2020-12-12 59:59:59
                                            </span>
                                        </div> */}
                                    </div>
                                </div>
                                <div className=' mt-4 w-full px-6'>
                                    <div className=' w-full  flex flex-row justify-between items-center'>
                                        <span className=" text-sm font-bold text-white">{t('p.总收益')}：
                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                fixedDecimalScale
                                                value={item.max}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                decimalScale={4} />
                                        </span>
                                        <span className=" text-sm  font-bold text-white">{t('p.已获取')}：
                                        <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                fixedDecimalScale
                                                value={item.all_bonus}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={false}
                                                decimalScale={4} /></span>
                                        </div>
                                        <div className=' mt-2 '>
                                        <Progress  strokeColor={{from: '#FCE53F',to: '#FAB34B',}} status="active"  showInfo={false}   percent={item.per} width={50} strokeWidth={16} />
                                    </div>
                                </div>
                                <div className=' mt-4 w-full px-6 flex flex-row justify-end items-end'>
                                    <button onClick={()=>hui(item.price,item.eth_state,item.order_num)}  className={` ${item.eth_state==0?'border-yellow1 text-logo':' border-gray-400 text-gray-400'}  ml-2 w-32 h-10  flex flex-row items-center justify-center  shadow-md   border     rounded-xl text-base     font-extrabold  hover:opacity-60`}>
                                        <img alt='rr' className=' mr-2' src={require('../../assets/icon/ethlogo.png')} style={{"width":"25px"}}></img>
                                        {item.eth_state==0?t('p.赎回'):t('p.已赎回')}
                                    </button>
                                    
                                </div>
                            </div>
                        
                        )
                    }):(
                        <div  className=' w-full h-36 pl-0 pr-4 pt-2 pb-4 mb-5  flex flex-row items-center justify-center   shadow-md shadow-gray-900   bg-gradient-to-r from-black  to-black-right  rounded-2xl  text-gray-400 text-xs relative'>
                        <div className=' w-16 h-8 bg-gradient-to-r from-yellow1  to-yellow2 absolute top-0 left-0 flex flex-row justify-center items-center text-base text-black font-bold rounded-tl-xl rounded-br-xl'>
                                    #0
                                </div>
                                No data
                        </div>
                    )
                }
                
                
            </div>



           
            
            <div className=' mt-4 text-center  text-xs text-gray-800'>
                {t('in.暂无更多内容')}
                </div>

                <div className=' w-full h-28'></div>


           
        </>
    );
    
}

export default connect(mapStateToProps)(Index);
